// project import
// import pages from './pages';
// import utilities from './utilities';
// import support from './support';
import dashboard from './dashboard';
import admin from './admin';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    admin
    // pages, utilities, support
  ]
};

export default menuItems;
